"use strict";
(function () {
  if (!customElements.get("progressbar-slider")) {
    class ProgressbarSlider extends HTMLElement {
      constructor() {
        super();
        this.slider = null;
        this.swiper = null;
      }

      connectedCallback() {
        this.setupElements();
        this.initSwiper();
      }

      disconnectedCallback() {
        if (this.swiper) {
          this.swiper.destroy();
        }
      }

      setupElements() {
        this.slider = this.querySelector('[data-component="slider"]');
        this.pagination = this.querySelector('[data-component="pagination"]');
      }

      initSwiper() {
        if (!this.slider) return;

        let { autoplay, rotate } = this.dataset;

        rotate = +rotate * 1000;
        autoplay =
          autoplay == "true"
            ? {
                delay: rotate,
                disableOnInteraction: false,
              }
            : false;

        this.swiper = new Swiper(this.slider, {
          slidesPerView: 1,
          grabCursor: true,
          autoplay,
          pagination: {
            el: this.pagination,
            clickable: true,
          },
        });
      }
    }

    customElements.define("progressbar-slider", ProgressbarSlider);
  }
})();
